export default __webpack_public_path__ + "static/media/simonhird.6293f8bf.png";